/**
 * Truncate a string to a specified length.
 * @param {string} str - The string to truncate.
 * @param {number} length - The maximum length of the truncated string.
 * @returns {string} The truncated string.
 */

export default function truncateString(str, length) {
  if (str.length <= length) {
    return str // If the string is already shorter than the length, return it as is.
  }

  let words = str.split(" ") // Split the string into words.
  let truncatedString = ""

  for (let word of words) {
    if ((truncatedString + word).length <= length) {
      truncatedString += word + " "
    } else {
      break
    }
  }

  // Remove any trailing space
  return truncatedString.trim() + "..."
}
